<template>
    <div>
        <v-container fluid>
            <v-row class="p-3">
                <v-col
                        v-for="(image,index) in img"
                        :key="image.id"
                        cols="12"
                        class="mx-3 my-2 card boxStyle"
                        md="2"
                        :data-img="image.id"
                >
                    <v-radio-group class="p-0 m-0" v-model="selectedImage">
                        <v-radio
                                color="indigo"
                                :value="image.value"
                        ></v-radio>
                    </v-radio-group>
                    <img :src="image.full_path"  class="img-fluid"
                         :key="image.id">
                    <p class="text-center my-0 pt-2">{{image.name}}</p>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import Swal from "sweetalert2";

export default {
    name: "baseStructure",
    data() {
        return {
            selectedImage: [],
            img: [
                {
                    id: '1',
                    name: 'تجاری',
                    value: 'promotional',
                    full_path: require('../../../../../../public/media/site/bannerStructure/تجاری.jpg')
                },
                {
                    id: '2',
                    name: 'فرهنگی',
                    value: 'culture',
                    full_path: require('../../../../../../public/media/site/bannerStructure/فرهنگی.jpg')
                },
                {
                    id: '3',
                    name: 'هنری',
                    value: 'art',
                    full_path: require('../../../../../../public/media/site/bannerStructure/هنری.jpg')
                },{
                    id: '4',
                    name: 'خلاق',
                    value: 'innovative',
                    full_path: require('../../../../../../public/media/site/bannerStructure/خلاق.jpg')
                },
                {
                    id: '5',
                    name: 'ورزشی',
                    value: 'sport',
                    full_path: require('../../../../../../public/media/site/bannerStructure/ورزشی.jpg')
                },
                {
                    id: '6',
                    name: 'تبلیغاتی',
                    value: 'commercial',
                    full_path: require('../../../../../../public/media/site/bannerStructure/تبلیغاتی.jpg')
                },
                {
                    id: '7',
                    name: 'خبری',
                    value: 'news',
                    full_path: require('../../../../../../public/media/site/bannerStructure/خبری.jpg')
                },

            ],
            count: 1,
        }
    },
    watch:{
        selectedImage() {
            this.$emit('persianName',this.img.find((x)=>x.value === this.selectedImage).name,"baseStructure")
            this.$emit('input', this.selectedImage)
        }
    }
}
</script>

<style scoped>

</style>